import { LegacyTheme } from "../../interfaces/Theme";

export const defaultColors: Partial<LegacyTheme> = {
    colorCorrect: "#296B33",
    colorError: "#DC2020",
};
